import { WarningIcon } from '@collinsonx/design-system/assets/icons';
import { Box, Flex, Stack, Text } from '@collinsonx/design-system/core';
import { BlockWrapper } from '@components/BlockWrapper/BlockWrapper';
import { BookingContext } from 'context/BookingContext';
import { useContext } from 'react';

import useLocale from '../../hooks/useLocale';
import classes from './BookingAmendmentPaymentInfoMessage.module.css';

interface BookingAmendmentPayInFullInfoMessageProps {
  showBorder?: boolean;
}

const BookingAmendmentPayInFullInfoMessage = ({
  showBorder = false,
}: BookingAmendmentPayInFullInfoMessageProps) => {
  const translations = useLocale();
  const { booking } = useContext(BookingContext);

  const {
    entitlementsAreAmended,
    priceIsAmended,
    selectedEntitlementsCount,
    usedEntitlementsCount,
  } = booking;

  const entitlementsForRefund =
    entitlementsAreAmended &&
    Math.max(usedEntitlementsCount - selectedEntitlementsCount, 0);

  const displayAmendPaymentMessage = priceIsAmended || entitlementsForRefund;

  if (!displayAmendPaymentMessage) return null;

  return (
    <BlockWrapper border={showBorder}>
      <Stack>
        <Flex align="top" gap="xs">
          <Box pt={2}>
            <WarningIcon style={{ height: 21, width: 21 }} />
          </Box>
          <Text className={classes.text}>
            {translations.booking.payment.amendmentPaymentPolicy}
          </Text>
        </Flex>
      </Stack>
    </BlockWrapper>
  );
};

export default BookingAmendmentPayInFullInfoMessage;
